import React from 'react';

const StudentRegistration = () => {
    return (
        <>
        </>
    )
}

StudentRegistration.propTypes = {}

export default StudentRegistration;